import { SidebarToggleButton } from '@src/shared/ui/Button';
import { Box } from '@src/shared/ui/layout';
import {
  SidebarContainer,
  SidebarDrawer,
  SidebarGroup,
  SidebarCollapsibleItem,
  SidebarItem,
  UserInfo,
} from './components';
import useSidebar from './useSidebar';

function Sidebar() {
  const sidebar = useSidebar();

  if (!sidebar) {
    return null;
  }

  const { isCollapsed, isExpanded, setHovered } = sidebar;

  return (
    <SidebarDrawer
      variant="permanent"
      open={!isCollapsed}
      hoverOpen={isCollapsed && isExpanded}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onMouseMove={() => { if (!isExpanded) setHovered(true); }}
    >
      <UserInfo />

      <SidebarContainer>
        <SidebarGroup sx={{ pt: 1 }}>
          {sidebar.items.top.map((item) =>
            item.children ? (
              <SidebarCollapsibleItem
                key={item.key}
                label={item.label}
                icon={item.icon}
                children={item.children}
              />
            ) : (
              <SidebarItem
                key={item.key}
                label={item.label}
                to={item.to}
                icon={item.icon}
              />
            )
          )}
        </SidebarGroup>

        <SidebarGroup>
          {sidebar.items.bottom.map((item) => (
            <SidebarItem
              key={item.key}
              label={item.label}
              to={item.to}
              icon={item.icon}
            />
          ))}

          <Box component="li" sx={{ p: isExpanded ? '13px 18px' : '13px 10px' }}>
            <SidebarToggleButton />
          </Box>
        </SidebarGroup>
      </SidebarContainer>
    </SidebarDrawer>
  );
}

Sidebar.displayName = 'Sidebar';
export default Sidebar;
